"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _AppBarActionUserAvatar = _interopRequireDefault(require("@sprinx/react-mui-layout/AppBarActionUserAvatar"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _useIsAuthenticated = _interopRequireDefault(require("../../auth/useIsAuthenticated"));

var _PersonIcon = _interopRequireDefault(require("../../icons/PersonIcon"));

var _LoginProvider = require("../../auth/LoginProvider");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    icon: {
      fill: theme.palette.common.black,
      width: 24,
      height: 24
    }
  };
}, {
  name: 'AppBarActionUser'
});

function AppBarActionUser(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className"]);
  var classes = useStyles({
    classes: pClasses
  });
  var isAuthenticated = (0, _useIsAuthenticated.default)();
  var handleOpenLogin = (0, _LoginProvider.useLoginDialogOpen)();
  var t = (0, _useTranslate.default)();
  return isAuthenticated ? /*#__PURE__*/_react.default.createElement(_AppBarActionUserAvatar.default, rest) : /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: t('appBarActionUser/title')
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, (0, _extends2.default)({
    onClick: handleOpenLogin
  }, rest), /*#__PURE__*/_react.default.createElement(_PersonIcon.default, {
    className: classes.icon
  })));
}

process.env.NODE_ENV !== "production" ? AppBarActionUser.propTypes = {
  classes: _propTypes.default.shape({
    icon: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string
} : void 0;
AppBarActionUser.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = AppBarActionUser;
exports.default = _default;